<template>
  <BaseNode v-bind="props">
    <template #header>
      <BaseHtmlContent class="node__title" :html="computedTitle" />
    </template>
    <template #body>
      <div class="portal-image-container">
        <img v-if="image" :src="image" />
      </div>
      <div class="portal-button-container">
        <sp-button tag="a" :href="link.url">{{ link.label }}</sp-button>
      </div>
    </template>
  </BaseNode>
</template>

<script setup>
import { useI18nInstance } from "#/shared/composables/useI18n";

import { isEmpty } from "lodash";
import { computed } from "vue";

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
  decisionTree: {
    type: Object,
    required: true,
  },
});

const context = props.decisionTree.context;
const patientType = context.patientType ?? "new";

const { t } = useI18nInstance();

const image = computed(() => {
  if (isEmpty(context.providerPortalLinks)) {
    return;
  }

  return context.providerPortalLinks[patientType].image;
});

const link = computed(() => context.providerPortalLinks[context.patientType]);

const computedTitle = computed(() => t(`nodes.send_to_portal.title.${context.patientType ?? "both"}`));
</script>

<style scoped lang="scss">
.portal-image-container {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;

  img {
    max-width: 100%;
    max-height: 115px;
  }
}
.portal-button-container {
  display: flex;
  justify-content: center;
}
</style>
